export const parseHtml = html => {
	const pattern = /<(“[^”]*”|'[^’]*’|[^'”>])*>/g;
	const htmlEntities = [/&amp;/g, /&lt;/g, /&gt;/g, /&nbsp;/g];
	let string = html.replace(pattern, '');
	htmlEntities.forEach(ent => (string = string.replace(ent, '')));
	return string;
};
